// Admin utility script to set admin access for a user
import { db } from '../firebaseConfig';
import { doc, setDoc, getDoc } from 'firebase/firestore';

/**
 * Sets admin role for a specific user
 * @param {string} userId - The Firebase user ID
 * @param {boolean} isAdmin - Whether to grant or revoke admin access
 * @returns {Promise<boolean>} - Success status
 */
export const setAdminRole = async (userId, isAdmin = true) => {
  if (!userId) {
    console.error('User ID is required');
    return false;
  }

  try {
    // Check if the user roles document already exists
    const userRoleRef = doc(db, 'userRoles', userId);
    const userRoleDoc = await getDoc(userRoleRef);

    // Prepare the role data
    let roleData = { admin: isAdmin };
    
    // If the document exists, preserve other roles
    if (userRoleDoc.exists()) {
      const existingRoles = userRoleDoc.data();
      roleData = { ...existingRoles, ...roleData };
    }

    // Set the admin role
    await setDoc(userRoleRef, roleData);
    
    return true;
  } catch (error) {
    console.error('Error setting admin role:', error);
    return false;
  }
};

/**
 * Creates a list of all users with admin privileges
 * This would require Admin SDK in a real application
 * For client-side, we would need to create a secure Cloud Function
 */
export const listAdmins = async () => {
  console.log('This functionality requires Firebase Admin SDK and should be implemented as a secure backend function');
  return [];
}; 